import { getColorHex as flooringColors } from "common/utils";
import { createModelPermissions } from "components/permissions/utils/model-permission-generator";

const FlooringConst = {
  ...createModelPermissions({
    modelName: "floorings",
    basePath: "/flooring",
    permissions: {
      VIEW: true,
      UPDATE: true,
      DELETE: true,
    },
  }),
  colorHexList: flooringColors,
};

export default FlooringConst;
